export default __webpack_public_path__ + "static/media/right-pink.3d0e669c.svg";